import "%blocks%/header/header";
import "%blocks%/secVideos/script";
import "%blocks%/secVideosSlider/script";
import "%blocks%/secFilms/script";
import "%blocks%/secMainNews/script";
import "%blocks%/secExclusiveNews/scripts";
import "%blocks%/secOtherNews/script";
import "%blocks%/newsTabs/script";
import "%blocks%/aboutUsTabs/script";
import "%blocks%/newsContentSmallSlider/script";
import "%blocks%/imageSlider/script";
import "%blocks%/otherFilmsTabs/script";
import "%blocks%/pages/test/script";
import "%blocks%/pages/search/script";
